import React, { useEffect, useState } from 'react'
import "./articles.scss"
import { Link } from 'react-router-dom'
import { useTheme } from '../../../contexts/ThemeProvider';
import { getFeaturedCategoriesBlogs } from '../../../utils/services';
import { formatBlogsDate } from '../../../utils/helpers';
import { DARK_THEME } from '../../../utils/constants';
import { useTranslation } from 'react-i18next';
const Articles = () => {
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { theme } = useTheme();
  const {t} = useTranslation();

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const featuresBlogsCategoriesData = await getFeaturedCategoriesBlogs();
        const blogs = featuresBlogsCategoriesData?.slice(0, 4) || [];
        setLatestBlogs(blogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <>
      {latestBlogs && latestBlogs.length > 0 && (
        <section className='main_articles'>
          <div className='custom-container'>
            <div className='inner_side_articles'>
              <div className="twice-elem">
                <h2>{t("Latest Articles")}</h2>
                <Link to="/blog">{t("View All")}</Link>
              </div>

              {isLoading ? (
                <div className="spinner__wrapper">
                  {theme === DARK_THEME ? (
                    <img width={50} src="/loader.svg" alt="loader" />
                  ) : (
                    <img width={50} className="loader_rotate" src="/loaderlight.svg" alt="loader" />
                  )}
                </div>
              ) : (
                <div className='cards_mains'>
                  {latestBlogs.map((blog, index) => (
                    <Link to={`/blog-detail?slug=${blog?.slug}`} key={index}>
                      <div className='card_one' key={index}>
                        <img
                          src={blog?.jetpack_featured_media_url || '/assets/banner/cardsimg.svg'}
                          className='imgcards img-fluid'
                          alt="blog"
                        />
                        <div className='middle_Div'>
                          <p>ARTICLE</p>
                          <svg xmlns="http://www.w3.org/2000/svg" width="3" height="4" viewBox="0 0 3 4" fill="none">
                            <circle cx="1.5" cy="2" r="1.5" fill="#8A8A8A" />
                          </svg>
                          <p>{blog?.category_name || 'NEWS'}</p>
                        </div>
                        <h3>{blog?.title?.rendered}</h3>
                        <h4>{formatBlogsDate(blog?.date)}</h4>
                      </div>
                    </Link>

                  ))}
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default Articles
